import { Dropdown } from 'antd'
import AIcon from '@/components/A/AIcon/AIcon'
import classNames from 'classnames'
import styles from './SwitchCorpOption.module.less'

type CorpMenuItem = {
  key: string
  name: string
}

type Props = {
  corpList: CorpMenuItem[]
  currentCorpKey?: string
  currentCorpName: string
  onChangeCorp: (corpId: string) => void
}

function SwitchCorpOption(props: Props) {
  const { corpList, currentCorpKey, currentCorpName, onChangeCorp } = props
  const corpMenuAlign = {
    points: ['tl', 'tr'],
    offset: [8, 0],
  }
  const menuItems = corpList.map((corp) => {
    return {
      key: corp.key,
      label: (
        <div
          className={classNames(styles.corpMenuItem, { [styles.active]: corp.key === currentCorpKey })}
          data-testid={`nav-corp-option-${corp.key}`}
        >
          {corp.name}
        </div>
      ),
    }
  })

  if (corpList.length > 1) {
    return (
      <div className={styles.switchCorpOption}>
        <Dropdown
          overlayClassName={styles.corpMenu}
          menu={{ items: menuItems, onClick: (item) => onChangeCorp(`${item.key}`) }}
          align={corpMenuAlign}
        >
          <button
            type='button'
            className={classNames(styles.actionRow, styles.actionRowButton)}
            data-testid='nav-corp-switch-btn'
          >
            <span className={styles.actionRowLeft}>
              <AIcon type='icon-qiyemingcheng' width={17} height={17} />
              {currentCorpName}
            </span>
            <span className={styles.actionRowRight}>
              <AIcon type='icon-line-global_right' width={16} height={16} />
            </span>
          </button>
        </Dropdown>
      </div>
    )
  }

  return (
    <div className={styles.switchCorpOption}>
      <div className={styles.actionRow} data-testid='nav-current-corp'>
        <span className={styles.actionRowLeft}>
          <AIcon type='icon-line-global_manageAccount' width={16} height={16} />
          {currentCorpName}
        </span>
      </div>
    </div>
  )
}

export default SwitchCorpOption
